export const DEFAULT_STATISTICS = {
  pvp: {
    X:0,
    O:0,
    draw:0
  },
  pvspc:{
    X:0,
    O:0,
    draw:0
  },
  pcvpc:{
    X:0,
    O:0,
    draw:0
  }
};

export const WIN_COMBINATION = [
  [0, 1, 2],
  [3, 4, 5],
  [6, 7, 8],
  [0, 3, 6],
  [1, 4, 7],
  [2, 5, 8],
  [0, 4, 8],
  [2, 4, 6],
];